import { useAuth } from '@clerk/clerk-react';
import { useCallback } from 'react';

export function useApiAuth() {
  const { getToken } = useAuth();
  const authFetch = useCallback(async (url, options = {}) => {
    const token = await getToken();
    const headers = { ...(options.headers || {}), Authorization: `Bearer ${token}` };
    let body = options.body;
    if (body && typeof body === 'object' && !(body instanceof FormData) && !(body instanceof Blob)) {
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(body);
    }
    const res = await fetch(url, { ...options, headers, body });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Request failed: ${res.status}`);
    }
    return res.json();
  }, [getToken]);
  return { authFetch };
}
